// Constants
import { APPLICATION_URL_PATH_PREFIX } from 'constants/environment'

// Helper: Route > Check if URL search parameters has key
function checkIfURLSearchParametersHasKey (key) {
	const searchParameters = new URLSearchParams(window.location.search)
	return searchParameters.has(key)
}

// Helper: Route > Get active page
function getActivePage (pathOrKey) {
	pathOrKey = pathOrKey || window.location.pathname
	if (pathOrKey?.startsWith(APPLICATION_URL_PATH_PREFIX)) {
		pathOrKey = pathOrKey.slice(APPLICATION_URL_PATH_PREFIX.length)
	}
	if (!pathOrKey) return
	return pathOrKey.startsWith('/') ? pathOrKey?.split('/')?.[1] : pathOrKey
}

// Helper: Route > Get full path
function getFullPath () {
	const { pathname, search } = window.location
	return pathname ? (pathname + (search || '')) : ''
}

// Helper: Route > Get URL search parameter
function getURLSearchParameter (key) {
	const searchParameters = new URLSearchParams(window.location.search)
	return searchParameters.get(key)
}

// Helper: Route > Remove URL search parameters
function removeURLSearchParameters (list, { willReplaceCurrent = false } = {}) {
	const url = new URL(document.location.href)
	const keysToRemove = list.filter(item => url.searchParams.has(item))
	if (keysToRemove.length === 0) return null
	keysToRemove.forEach(key => url.searchParams.delete(key))
	const entries = Object.fromEntries(url.searchParams)
	window.history[willReplaceCurrent ? 'replaceState' : 'pushState'](entries, document.title, url)
}

// Helper: Route > Reset URL search parameters
function resetURLSearchParameters () {
	window.history.replaceState({}, document.title, window.location.pathname)
}

// Helper: Route > Set URL search parameter
function setURLSearchParameter (key, value, { willReplaceCurrent = false } = {}) {
	const url = new URL(document.location.href)
	url.searchParams.set(key, value)
	const entries = Object.fromEntries(url.searchParams)
	window.history[willReplaceCurrent ? 'replaceState' : 'pushState'](entries, document.title, url)
}

// Export
export {
	checkIfURLSearchParametersHasKey,
	getActivePage,
	getFullPath,
	getURLSearchParameter,
	removeURLSearchParameters,
	resetURLSearchParameters,
	setURLSearchParameter
}
